import React, { useState } from 'react';
import { func, shape, string } from 'prop-types';
import SampleIntervalSelect from '../FormFields/SampleIntervalSelect';

const EditableIntervalFormatter = ({ name, onChange, row }) => {
    const [value, setValue] = useState(row[name] || 15);

    function handleChange(event) {
        const { name, value } = event.target;
        setValue(event.target.value);
        onChange(name, value, row);
    }

    return (
        <SampleIntervalSelect
            name={name}
            onChange={handleChange}
            showLabel={false}
            type={row.dataType}
            value={value}
        />);
};

EditableIntervalFormatter.defaultProps = {
    onChange: () => {},
    row:      {}
};

EditableIntervalFormatter.propTypes = {
    name:     string,
    onChange: func,
    row:      shape({
        id: string
    })
};

export default EditableIntervalFormatter;
